import { CurrencyPipe, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { StorageService } from '@tae/services';
import { RechargeInterface } from 'src/app/interfaces/ctrl-recharge.interface';
import { PageViewInferface, SetEventInterface } from 'src/app/interfaces/tagging.interface';
import { CtrlRechargeService } from 'src/app/services/ctrl-recharge/ctrl-recharge.service';
import { TaggingService } from 'src/app/services/tagging.service';

@Component({
    selector: 'app-recharge-schedules',
    templateUrl: './recharge-schedules.component.html',
    styleUrls: ['./recharge-schedules.component.scss'],
    standalone: false
})
export class RechargeSchedulesComponent implements OnInit {

  data: any;

  public isActiveCalendar: boolean = false;

  public dateCalendar: any = null;

  public dateFormatSelected: string = '';

  public arrayFrecuency: any[] = [
    { value: 'SEMANAL', label: 'Semanal', active: false },
    { value: 'QUINCENAL', label: 'Quincenal', active: false },
    { value: 'MENSUAL', label: 'Mensual', active: false }
  ];

  public arrayDetailsRecharge: any[] = [];

  public formRecharge: FormGroup;

  public activeBtnForm: boolean = false;

  get recharge(): RechargeInterface {
    return this.crs.recharge
  }

  get amount(): number {
    const find = this.arrayDetailsRecharge.find(_item => _item.id === 'amount');
    return find ? find.data : this.recharge.amount;
  }

  public get textTokens(): any {
    return this.crs.textTokens;
  }
  
  constructor(
    private _datePipe: DatePipe,
    private crs: CtrlRechargeService,
    private taggingService: TaggingService,
    private storageService: StorageService,
  ) { }

  private _createForm() {
    this.formRecharge = new FormGroup({
      alias: new FormControl('')
    });

    this.formRecharge.valueChanges.subscribe(() => {
      this.aliasChange();
    });
  }

  public clickChip(item: any) {
    this.isActiveCalendar = false;
    this._updateFrecuency(item.value);
    this._setNextDate(null);
  }

  public selectDay(day: any) {
    this.isActiveCalendar = !this.isActiveCalendar;
  }

  public eventSelectedDay(event: any) {
    this.dateCalendar = event;
    this._setNextDate(this.dateCalendar);
    this.isActiveCalendar = false;
  }

  private _formatDate() {
    const day = this._datePipe.transform(this.dateCalendar, 'dd') ?? '';
    const month = this._datePipe.transform(this.dateCalendar, 'LLLL') ?? '';
    const year = this._datePipe.transform(this.dateCalendar, 'YYYY') ?? '';
    this.dateFormatSelected = `${day} de ${month} ${year}`;
    this._setData(this.dateFormatSelected, 'rechargeFirst', this.dateCalendar);
  }

  private _setNextDate(date: Date | null) { 
    if (!date) {
      const dayNow =  new Date();
      const frecuency = this.arrayFrecuency.find(item => item.active === true)?.value;
      switch (frecuency) {
        case 'SEMANAL':
          this.dateCalendar = this._getLastDayOfWeek(dayNow);
          break;
        case 'QUINCENAL':
          this.dateCalendar = this.getLastDayOfFortnight(dayNow);
          break;
        default:
          this.dateCalendar = this.getLastDayOfNextMonth(dayNow);
          break;
      }
    }
    this._formatDate();
  }

  private _updateFrecuency(frecuency: string) {
    if (frecuency) {
      this.arrayFrecuency = this.arrayFrecuency.map(item => {
        return { ...item, active: item.value === frecuency };
      });

      this._setData(frecuency, 'frecuency', frecuency);
    } else {
      this.arrayFrecuency = this.arrayFrecuency.map(item => {
        return { ...item, active: item.value === 'MENSUAL' };
      });
      this._setData('MENSUAL', 'frecuency', 'MENSUAL');
    }
  }

  private _setData(value: string, id: string, data: any, active: boolean = true) {
    if (this.arrayDetailsRecharge.length > 0) {
      this.arrayDetailsRecharge = this.arrayDetailsRecharge.map(item => {
        if (item.id === id) {
          return { ...item, 
                value: value,
                data: data,
                active: active 
              };
        }
        return item;
      });
    }
    this._validActiveBtn();
  }

  public aliasChange() {
    if (this.formRecharge.valid) {
      this._setData(this.formRecharge.value.alias, 'alias', this.formRecharge.value.alias);
    } else {
      this._setData('', 'alias', null);
    }
  }

  private _validActiveBtn() {
    const data = this.arrayDetailsRecharge.filter(item => item.id !== 'alias' && item.value === '');
    this.activeBtnForm = data.length > 0 ? false : true;
  }

  public saveRecharge() {
    this.data.$getDataEditRecharges.next(this.arrayDetailsRecharge);
    const event: SetEventInterface = {
      event: "payments",
      categoria: "recarga_celular",
      accion: "pago_automatico",
      etiqueta: "guardar",
      canalBanco: "supermovil",
      url: "recarga_celular/pago_automatico",
      userID: "",
    }
    this.taggingService.setEvent(event);
  }

  public allowOnlyLetters(_event: Event) {
    const input = _event.target as HTMLInputElement;
    const value = input.value;
    const clear = value.replace(/[^\p{L}\p{N} ]/gu, '');
    if (value !== clear) {
      input.value = clear
      this.formRecharge.get('alias').patchValue(clear, { emitEvent: false });
    }
  }

 
  // Último día de la semana (domingo)
  private _getLastDayOfWeek(date: Date) {
    const result = new Date(date);
    result.setDate(result.getDate() + 7);
    return new Date(result);
  }

  // Último día de la quincena (15 o último del mes)
  private getLastDayOfFortnight(date: Date) {
    const result = new Date(date);
    result.setDate(result.getDate() + 15);
    return new Date(result);
  }

  // Último día del mes
  private getLastDayOfNextMonth(date: Date) {
    const newDate = new Date(date)
    return newDate.setMonth(newDate.getMonth() + 1);
  }
  
  ngOnInit() {
    this._createForm();
    let frecuency = 'MENSUAL';
    console.log(this.data, 'ngOnInit');
    
    if (this.data?.arrayDetailsRecharge.length > 0) {
      this.arrayDetailsRecharge = this.data?.arrayDetailsRecharge;
      const frecuencyByDetails = this.arrayDetailsRecharge.find(item => item.id === 'frecuency');
      frecuency = frecuencyByDetails?.data;
      const rechargeFirst = this.arrayDetailsRecharge.find(item => item.id === 'rechargeFirst');
      const alias = this.arrayDetailsRecharge.find(item => item.id === 'alias');
      if (rechargeFirst?.value) {
        this.dateCalendar = new Date(rechargeFirst.data);
      }

      if (alias) {
        this.formRecharge.patchValue({ alias: alias.value });
      }
    }
    this._setNextDate(this.dateCalendar);
    this._updateFrecuency(frecuency);
    this.taggingPage();
  }

  private taggingPage(): void {
    const frecuency = this.arrayDetailsRecharge.find(item => item.id === 'frecuency');
    const page: PageViewInferface = {
      url: 'recarga_celular/pago_automatico',
      canalBanco: "supermovil",
      titulo: 'recarga_celular|pago_automatico',
      subsection1: 'recarga_celular',
      userId: '',
      entorno: this.storageService.get("ENV"),
      proceso: 'recarga_automatica',
      periodicidad: (frecuency.value as string).toLowerCase(),
      event: "PageView",
    };
    this.taggingService.setPageView(page);
  }

  onAmounts(_view: boolean): void {
    const data = { arrayDetailsRecharge: this.arrayDetailsRecharge, amount: true };
    this.data.$getDataEditRecharges.next(data);
    // this.data.$getDataEditRecharges.next(undefined);
  }
}
